<adapt-dialog [maxWidth]="700">
    <h3 adapt-dialog-title>{{ title }}</h3>

    <ng-container adapt-dialog-content>
        <div class="alert alert-guidance">
            <p>Guidance materials are documents, videos, wiki pages, etc that are stored externally to Lumia but may be useful to guide
                people on how to perform tasks in the organisation.</p>
            <p>Enter the name of the guidance material and the url to access it below.</p>
            <p>
                <strong>NB: The guidance material needs to be stored in a location accessible via your web browser.</strong>
            </p>
        </div>

        <div class="form-group">
            <label>Name</label>
            <dx-text-box [(value)]="dialogData.guidanceMaterial.name"
                         [adaptValidateEntity]="dialogData.guidanceMaterial"
                         adaptValidateEntityProperty="name"
                         placeholder="Enter guidance material name"
                         data-test="guidance-material-name-input"></dx-text-box>
        </div>

        <div class="form-group">
            <label>Link</label>
            <adapt-select-document [(url)]="dialogData.guidanceMaterial.locationUrl"
                                   data-test="guidance-material-link-input"
                                   (selectedDocumentChange)="clearErrorMessage()"
                                   (selectedDocumentError)="setErrorMessage($event)"></adapt-select-document>
        </div>

        <div class="form-group mb-0">
            <label>Description</label>
            <adapt-html-editor [(contents)]="dialogData.guidanceMaterial.description"
                               (isValidChange)="isEditorValid = $event"></adapt-html-editor>
        </div>

        @if (saveError) {
            <div role="alert"
                 class="mt-3 alert alert-danger">
                {{ saveError }}
            </div>
        }
    </ng-container>

    <adapt-standard-dialog-buttons adapt-dialog-footer
                                   [saveIsDisabled]="isInvalid"
                                   [saveBlockingClick]="saveAndClose"
                                   (cancelClick)="cancel()"> </adapt-standard-dialog-buttons>
</adapt-dialog>
